import { redirectTo } from 'Utils/window';
import { LOCATION_SEARCH_SELECT_LOCATION_SUCCESS } from 'CoreComponents/locationSearch/events';
import { toQueryString } from 'Utils/queryString';

const SELECTOR = {
  headerCategorySelect: '#headerCategorySelect',
  asideCategorySelect: '#asideCategorySelect',
  headerCalendar: '#headerCalendar',
  asideCalendar: '#asideCalendar',
  locationFilter: '.form-photographer-filter__group--location .location-search__input',
  priceFilter: '.form-photographer-filter__slider',
  toggleFilterButton: '.form-photographer-filter__btn-toggle-advanced-filter',
  advancedFilter: '.form-photographer-filter__advanced-filter',
  sliderContainer: '.slider__container',
  bookingType: '.form-photographer-filter__booking-type',
  buttonBookingType: '.form-photographer-filter__btn-booking-type',
  locationPlaceIdInput: '.form-photographer-filter__location-place-id-input'
};

const CLASS_NAME = {
  advancedFilterExpanded: 'form-photographer-filter__advanced-filter--expanded'
};

class PhotographerFilterForm {
  constructor(elementRef) {
    // Initialise attributes
    this.elementRef = elementRef;
    this.toggleFilterButton = elementRef.querySelector(SELECTOR['toggleFilterButton']);
    this.advancedFilter = elementRef.querySelector(SELECTOR['advancedFilter']);

    // Bind functions
    this.changeHandler = this.changeHandler.bind(this);
    this.categoryChangeHandler = this.categoryChangeHandler.bind(this);
    this.dateChangeHandler = this.dateChangeHandler.bind(this);
    this.toggleFilterButtonClickHandler = this.toggleFilterButtonClickHandler.bind(this);
    this.changeBookingTypeHandler = this.changeBookingTypeHandler.bind(this);

    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler triggered when the form elements are changed.
   *
   * @param {Event} _event - click event.
   * */
  changeHandler(_event) {
    this._submitForm();
  }

  /**
   * Event handler triggered when category select elements are changed.
   *
   * @param {Event} event - click event.
   * */
  categoryChangeHandler(event) {
    document.querySelector(SELECTOR['headerCategorySelect']).value = event.target.value;
    document.querySelector(SELECTOR['asideCategorySelect']).value = event.target.value;
  }

  /**
   * Event handler triggered when calendar elements are changed.
   *
   * @param {Event} event - click event.
   * */
  dateChangeHandler(event) {
    document.querySelector(SELECTOR['headerCalendar']).value = event.target.value;
    document.querySelector(SELECTOR['asideCalendar']).value = event.target.value;
  }

  /**
   * Event handler triggered when toggleFilterButton is clicked.
   *
   * @param {Event} event - click event.
   * */
  toggleFilterButtonClickHandler(event) {
    this.advancedFilter.classList.toggle(CLASS_NAME['advancedFilterExpanded']);
  }

  /**
   * Event handler triggered when the button to switch booking type is clicked.
   *
   * @param {Event} event - click event.
   * */
  changeBookingTypeHandler(event) {
    event.preventDefault();

    const bookingType = event.currentTarget.dataset['bookingType'];
    const redirectPath = bookingType === 'instant' ? '/photographers/now' : '/photographers';
    let formData = this._serialiseLocationForm();
    let queryString = toQueryString(formData);

    redirectTo(`${window.location.origin}${redirectPath}?${queryString}`);
  }

  // Private Methods

  /**
   * Serialises the form values into request params.
   * */
  _serialiseForm() {
    let priceFilterValue = this._priceFilterValue();

    return ({
      'filter[location]': document.querySelector(SELECTOR['locationFilter']).value,
      'filter[category_id]': document.querySelector(SELECTOR['asideCategorySelect']).value,
      'filter[date]': document.querySelector(SELECTOR['asideCalendar']).value,
      'filter[price][min]': priceFilterValue[0],
      'filter[price][max]': priceFilterValue[1],
      'filter[location_place_id]': document.querySelector(SELECTOR['locationPlaceIdInput']).value
    });
  }

  /**
   * Serialises the only the location-related form values into request params.
   * */
  _serialiseLocationForm() {
    return ({
      'filter[location]': document.querySelector(SELECTOR['locationFilter']).value
    });
  }

  /**
   * Serialize form values and redirects to the search results page
   * */
  _submitForm() {
    let formData = this._serialiseForm();
    let queryString = toQueryString(formData);
    redirectTo(`${window.location.origin}${window.location.pathname}?${queryString}`);
  }

  /**
   * Reads the price range from the slider filter
   * */
  _priceFilterValue() {
    let sliderElement = document.querySelector(SELECTOR['sliderContainer']);

    if (sliderElement.getAttribute('disabled') === 'true') { return ''; }

    let priceRange = sliderElement.noUiSlider.get();

    return (
      priceRange.map(price => { return parseInt(price); })
    );
  }

  /**
   * Adds scroll event listeners.
   * */
  _addEventListeners() {
    const headerCategorySelect = document.querySelector(SELECTOR['headerCategorySelect']);
    const asideCategorySelect = document.querySelector(SELECTOR['asideCategorySelect']);
    const headerCalendar = document.querySelector(SELECTOR['headerCalendar']);
    const asideCalendar = document.querySelector(SELECTOR['asideCalendar']);
    const priceFilter = document.querySelector(SELECTOR['priceFilter']);
    const buttonBookingType = document.querySelector(SELECTOR['buttonBookingType']);
    const locationFilter = document.querySelector(SELECTOR['locationFilter']);
    // As there are two category select elements, symlink their values
    headerCategorySelect && headerCategorySelect.addEventListener('change', this.categoryChangeHandler);
    asideCategorySelect && asideCategorySelect.addEventListener('change', this.categoryChangeHandler);

    // As there are two date select elements, symlink their values
    headerCalendar && headerCalendar.addEventListener('change', this.dateChangeHandler);
    asideCalendar && asideCalendar.addEventListener('change', this.dateChangeHandler);

    // Change Handlers
    headerCategorySelect && headerCategorySelect.addEventListener('change', this.changeHandler);
    asideCategorySelect && asideCategorySelect.addEventListener('change', this.changeHandler);
    headerCalendar && headerCalendar.addEventListener('change', this.changeHandler);
    asideCalendar && asideCalendar.addEventListener('change', this.changeHandler);
    priceFilter && priceFilter.addEventListener('change', this.changeHandler);
    locationFilter && locationFilter.addEventListener(LOCATION_SEARCH_SELECT_LOCATION_SUCCESS, this.changeHandler);

    // Click Handlers
    buttonBookingType && buttonBookingType.addEventListener('click', this.changeBookingTypeHandler);

    this.toggleFilterButton && this.toggleFilterButton.addEventListener('click', this.toggleFilterButtonClickHandler);
  }
}

export default PhotographerFilterForm;
